
import { useParams } from 'react-router-dom';
import { PresentacionesFormState } from '../../../context/presentaciones/PresentacionesFormState';
import { Form } from './form';

export const PresentacionesFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Presentacion":"Crear Presentacion";
  
  return (
    <PresentacionesFormState>
        <br />
        <Form title={title} />
    </PresentacionesFormState>
  );
};
